import { render, staticRenderFns } from "./DefaultPageLayout.vue?vue&type=template&id=4a7e0883&scoped=true&"
import script from "./DefaultPageLayout.vue?vue&type=script&lang=js&"
export * from "./DefaultPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPageLayout.vue?vue&type=style&index=0&id=4a7e0883&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7e0883",
  null
  
)

export default component.exports